<div>
    <app-cockpit-title />

    <div class="widgets-grid">
        <app-task-widget *appShowAuthorize="'APP_TASKS_READ'" [customerSpaceId]="customerSpaceId" />
        <app-document-widget *appShowAuthorize="'APP_DOCUMENTS_READ'" [customerSpaceId]="customerSpaceId" />

        <app-process-widget processType="FinancialStatementWorkings"
            *appShowAuthorize="'APP_FILE_PROCESS_READ'; options: { values: { processType: 'FinancialStatementWorkings' } }"
            [customerSpaceId]="customerSpaceId" />
        <app-process-widget processType="TaxDeclaration"
            *appShowAuthorize="'APP_FILE_PROCESS_READ'; options: { values: { processType: 'TaxDeclaration' } }"
            [customerSpaceId]="customerSpaceId" />
        <app-process-widget
            *appShowAuthorize="'APP_FILE_PROCESS_READ'; options: { values: { processType: 'Audit' } }"
            processType="Audit" [customerSpaceId]="customerSpaceId" />

        <div *ngIf="showEditorOrPayrollWidget$ | async" class="account-widgets-container">
            <app-creditor-widget
                *appShowAuthorize="'APP_INBOX_UPLOAD_READ'; options: { values: { inbox: 'creditor' } }"
                [customerSpaceId]="customerSpaceId" />
            <app-payroll-widget
                *appShowAuthorize="'APP_INBOX_UPLOAD_READ'; options: { values: { inbox: 'payroll' } }"
                [customerSpaceId]="customerSpaceId" />
        </div>

        <app-project-widget *appShowAuthorize="'APP_PROJECTS_READ'" [customerSpaceId]="customerSpaceId"
            class="projects-widget-item" />
    </div>
</div>